'use client';
import LogoIcon from '@/components/global/LogoIcon';
import {
  customRichTextComponent,
  richTextComponent,
} from '@/sanity/sanityPortableText';
import { PortableText } from 'next-sanity';
import { data } from 'tailwindcss/defaultTheme';
import BackgroundTexture from './BackgroundTexture';
import { PortableTextBlock } from 'sanity';
import { motion } from 'framer-motion';
import { GROQButton } from '@/sanity/lib/definitions';
import { CTAButton } from '@/shadcn/ui/button';

interface IValueThroughVeylorProps {
  title: PortableTextBlock[];
  mobileButton: GROQButton;
}

export default function ValueThroughVeylor({
  title,
  mobileButton,
}: IValueThroughVeylorProps) {
  return (
    <section className="lg:py-[25.75rem] py-[15rem] bg-[#F5F8FF] relative z-10 overflow-clip">
      <motion.div
        initial={{ clipPath: 'inset(0% 0% 100% 0%)' }}
        whileInView={{ clipPath: 'inset(0% 0% 0% 0%)' }}
        transition={{ duration: 2, ease: [0.25, 1, 0.5, 1] }}
        className="container z-10 flex relative flex-col gap-[4rem] lg:gap-[5rem] items-center text-center text-black prose-h2:uppercase prose-h2:text-[5rem] prose-h2:lg:text-[10.19rem] prose-h2:font-[200] prose-h2:leading-[100%] prose-p:lg:w-[110rem] prose-p:lg:text-[2rem] prose-p:text-[1.75rem] prose-p:leading-[160%]"
      >
        <LogoIcon className="w-[8.4rem] lg:w-[9.86rem]" />
        {title && (
          <PortableText
            value={title}
            components={customRichTextComponent({
              block: {
                h2: ({ children }) => (
                  <h2 className=" relative">
                    <span className="absolute w-[70%] lg:w-1/2 left-1/2 -translate-x-1/2  flex items-center justify-between font-nunito text-[1rem] lg:text-[1.375rem] tracking-[0.45375rem] uppercase text-black">
                      <span className="block">VEYLOR</span>
                      <span className="block">VEYLOR</span>
                    </span>
                    {children}
                  </h2>
                ),
              },
            })}
          />
        )}

        <motion.div
          className="w-full mb-[2rem] lg:mb-0 lg:py-[1rem]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 3, ease: [0.25, 1, 0.5, 1] }}
        >
          {mobileButton && <CTAButton data={mobileButton} />}
        </motion.div>
      </motion.div>

      <BackgroundTexture className="absolute top-[45%] lg:top-[70rem] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[240rem] border border-red-500 h-[240rem] pointer-events-none select-none" />
    </section>
  );
}
